import { Footer } from "./Footer";
import { Hero } from "./Hero";
import { Nav } from "./Nav";
import { graphite } from "./theme";

export type LandingPageProps = {
  currentUser: { name: string; appUrl: string } | null;
  signInUrl: string;
  copyrightYear: number;
};

export function LandingPage(props: LandingPageProps) {
  const theme = graphite;
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        background: theme.bg,
        color: theme.fg,
        fontFamily: theme.font,
      }}
    >
      <Nav theme={theme} signInUrl={props.signInUrl} currentUser={props.currentUser} />
      <Hero theme={theme} />
      <Footer theme={theme} copyrightYear={props.copyrightYear} />
    </div>
  );
}
